
    <div class="refresh" *ngIf="editMode">
      <span class="glyphicon glyphicon-refresh" (click)="refresh()"></span>
    </div>
    <p>
      cms-block-multi-product works!
    </p>
  